import { AnalyticsBrowser } from "@segment/analytics-next";
import { SEGMENT_KEY } from "./constants";
import type { FBUser } from "./types";

export const analytics = AnalyticsBrowser.load({ writeKey: SEGMENT_KEY });

export const WrapperStyles = {
  flex: 1,
  width: "100%", // Full viewport width
  height: "100%", // Full viewport height
  backgroundColor: "#0c0c0d",
  backgroundImage: "url(/images/dot-pattern.svg)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  display: "flex", // Use flexbox
  flexDirection: "column", // Stack content vertically
  alignItems: "center",
  justifyContent: "center",
};

export const getOrdinalSuffix = (day: number): string => {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatEpochToDate = (epochTimestamp: number): string => {
  // Convert epoch to Date object (handle both seconds and milliseconds)
  const date = new Date(
    epochTimestamp < 10000000000 ? epochTimestamp * 1000 : epochTimestamp,
  );
  // Get month name
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const ordinalSuffix = getOrdinalSuffix(day);
  return `${month} ${day}${ordinalSuffix}`;
};

export const capitalizeWord = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const getUsername = (
  user: FBUser,
  hasPermission: boolean = true,
): string => {
  if (user.firstName && hasPermission) {
    return `${capitalizeWord(user.firstName)}`;
  } else {
    return user.username;
  }
};
